import Client from "../client";
import {NewScopedUserRoleResource, ScopedUserRoleResource} from "../resources/scopedUserRoleResource";
import MixedScopeBaseRepository from "./mixedScopeBaseRepository";

class ScopedUserRoleRepository extends MixedScopeBaseRepository<ScopedUserRoleResource, NewScopedUserRoleResource> {
    constructor(client: Client) {
        super("ScopedUserRoles", client);
    }
}

export default ScopedUserRoleRepository;